import { useTranslation } from 'react-i18next'
import { Select as MuiSelect } from '@mui/material'
import { MenuItem, Select as VaporSelect } from '@vapor/material'
import { displayFiscalType } from 'src/utils/fiscal-type'
import { FiscalType } from 'src/api/api.generated'
const Select = VaporSelect as unknown as typeof MuiSelect

export type CheckoutFiscalTypeInputProps = {
  value: FiscalType | null
  onChange: (value: FiscalType | null) => void
  error?: boolean
  disabled?: boolean
}

export default function CheckoutFiscalTypeInput({ value, onChange, error, disabled }: CheckoutFiscalTypeInputProps) {
  const { t } = useTranslation()

  if (disabled) return <>{displayFiscalType(t, value)}</>

  return (
    <Select<FiscalType | ''> //
      fullWidth
      value={value !== null ? value : ''}
      error={error}
      disabled={disabled}
      onChange={(event) => {
        switch (event.target.value) {
          case FiscalType.INVOICE:
            onChange(FiscalType.INVOICE)
            break
          case FiscalType.RECEIPT:
            onChange(FiscalType.RECEIPT)
            break
          default:
            onChange(null)
            break
        }
      }}
    >
      <MenuItem value={FiscalType.INVOICE}>{displayFiscalType(t, FiscalType.INVOICE)}</MenuItem>
      <MenuItem value={FiscalType.RECEIPT}>{displayFiscalType(t, FiscalType.RECEIPT)}</MenuItem>
    </Select>
  )
}
